'use client';

import dynamic from 'next/dynamic';
const SentryInit = dynamic(() => import('./sentry-init'), {
  ssr: false,
  loading: () => null
});
const MonitoringHelper = () => {
  return <SentryInit data-sentry-element="SentryInit" data-sentry-component="MonitoringHelper" data-sentry-source-file="index.tsx" />;
};
export default MonitoringHelper;